/**
 * Cuánto pesa un anunciante, según cuántos anuncios tiene ACTIVOS en total.
 *
 * Es otra cosa que las copias del creativo. Las copias dicen cuántas veces repite ESE
 * anuncio; esto dice el tamaño de toda su operación. Un anunciante puede correr un creativo
 * repetido diez veces —una apuesta concentrada— o cien creativos distintos, que es una
 * máquina montada. Lo segundo significa que lo que copies ya lo validó un presupuesto.
 *
 * Los cortes son los que pediste: 15 fuerte, 25 muy fuerte, 50 bestia, 100 animal.
 */

export interface Tier {
  /** Desde cuántos anuncios activos aplica. */
  min: number;
  label: string;
  color: string;
  /** Fondo y borde, ya listos para el estilo en línea. */
  bg: string;
  border: string;
}

/** De mayor a menor: el primero que cumpla manda. */
export const TIERS: Tier[] = [
  { min: 100, label: 'animal de animales', color: '#f87171', bg: '#f871711f', border: '#f8717159' },
  { min: 50, label: 'bestia', color: '#fb923c', bg: '#fb923c1f', border: '#fb923c59' },
  { min: 25, label: 'muy fuerte', color: '#fbbf24', bg: '#fbbf241f', border: '#fbbf2459' },
  { min: 15, label: 'fuerte', color: '#a3e635', bg: '#a3e6351f', border: '#a3e63559' }
]

/** El nivel que le toca, o null si no llega al primer corte o no se sabe su tamaño. */
export function tierOf(activeAds?: number | null): Tier | null {
  if (typeof activeAds !== 'number' || activeAds <= 0) return null
  return TIERS.find(t => activeAds >= t.min) ?? null
}

/** Opciones para el filtro, de menos a más exigente. */
export const TIER_OPTIONS = [
  { value: '', label: 'Cualquier tamaño' },
  ...[...TIERS].reverse().map(t => ({ value: String(t.min), label: `${t.label} · ${t.min}+ anuncios` }))
]
